import {Component, Input} from '@angular/core';
import {EventContactResponse, EventResponse} from '../../../../../../../../@shared/models/response.module';
import {EventsService} from '../../../../../../../../@shared/services/events-service';
import {_AQH_EVE_24, _AQH_EVE_27} from '../../../../../../../../@shared/models/input.module';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AddContact} from './components/add-contact/add-contact';
import {EditContact} from './components/edit-contact/edit-contact';
import {DeleteModal} from '../../../../../../../../@shared/components/delete-modal/delete-modal';

@Component({
  selector: 'app-manage-event-contacts',
  standalone: false,
  templateUrl: './manage-event-contacts.html',
  styleUrl: './manage-event-contacts.css'
})
export class ManageEventContacts {
  @Input() event: EventResponse
  contacts: EventContactResponse[] = []
  loading: boolean = false;

  constructor(private eventsService: EventsService,
              private modalService: NgbModal) {
  }

  ngOnInit() {
    this.getContacts()
  }

  getContacts() {
    this.loading = true;
    let payload: _AQH_EVE_24 = {
      event_id: this.event.event_id
    }
    this.eventsService.getEventContacts(payload).subscribe({
      next: (res: EventContactResponse[]) => {
        this.contacts = res.sort((a, b) => a.role_id - b.role_id);
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        this.contacts = []
      }
    })
  }

  openModal() {
    let modalRef = this.modalService.open(AddContact, { size: 'lg', centered: true });
    modalRef.componentInstance.event = this.event;
    modalRef.result.then((result) => {
      if (result) {
        this.getContacts();
      }
    }, () => {});
  }

  openEditModal(contact: EventContactResponse) {
    let modalRef = this.modalService.open(EditContact, { size: 'lg', centered: true });
    modalRef.componentInstance.contact = contact;
    modalRef.componentInstance.event = this.event;
    modalRef.result.then((result) => {
      if (result) {
        this.getContacts();
      }
    }, () => {});
  }

  deleteContact(contact: EventContactResponse) {
    let modalRef = this.modalService.open(DeleteModal, { centered: true });
    modalRef.componentInstance.description = 'Are you sure you want to remove this contact from the event? This action cannot be undone.';
    modalRef.result.then((result) => {
      if (result) {
        let params: _AQH_EVE_27 = {
          contact_id: contact.contact_id
        }
        this.eventsService.deleteEventContact(params).subscribe(() => {
          this.getContacts();
        });
      }
    }, () => {})
  }
}
